import React from "react";
import { Badge, ProgressBar } from "react-bootstrap";

export default function PainChart({ painScore }) {
  const v = Math.min(Math.max(Number(painScore) || 0, 0), 10);
  const pct = (v / 10) * 100;
  const variant = v <= 3 ? "success" : v <= 6 ? "warning" : "danger";
  const tone = v <= 3 ? "Mild" : v <= 6 ? "Moderate" : "Severe";
  const FACES = [
    { emoji: "😀", label: "No pain" },
    { emoji: "🙂", label: "Mild" },
    { emoji: "🙂", label: "Mild-moderate" },
    { emoji: "😐", label: "Moderate" },
    { emoji: "😐", label: "Moderate" },
    { emoji: "😟", label: "Moderate-severe" },
    { emoji: "😟", label: "Severe" },
    { emoji: "😣", label: "Severe" },
    { emoji: "😖", label: "Very severe" },
    { emoji: "😫", label: "Very severe" },
    { emoji: "😭", label: "Worst possible" },
  ];
  const isValidScore = (v) =>
    typeof v === "number" && Number.isInteger(v) && v >= 0 && v <= 10;

  const currentFace = isValidScore(Number(painScore))
    ? FACES[Number(painScore)]
    : null;
  const getColor = (i) => {
    if (i === 0) return "#4caf50";
    if (i <= 3) return "#8bc34a";
    if (i <= 6) return "#ffc107";
    if (i <= 8) return "#ff9800";
    return "#f44336";
  };
  return (
    <>
      <div className="text-center mb-3">
        <div
          style={{
            fontSize: "3.5rem",
            lineHeight: 1,
            transition: "transform 0.15s ease",
            transform: currentFace ? "scale(1.1)" : "scale(1)",
          }}
          aria-hidden="true"
        >
          {currentFace ? currentFace.emoji : "🙂"}
        </div>
      </div>
      <div style={{ fontFamily: "sans-serif", width: "100%" }}>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div style={{ fontWeight: 600, fontSize: 28, color: "#1C2B2A" }}>
            {v}
            <span
              style={{
                fontSize: 14,
                color: "#8C9C99",
                fontWeight: 500,
                marginLeft: 2,
              }}
            >
              /10
            </span>
          </div>
          <Badge
            bg={variant}
            style={{ color: variant === "warning" ? "#412402" : undefined }}
          >
            {tone}
          </Badge>
        </div>

        <ProgressBar now={pct} variant={variant} style={{ height: 8 }} />
      </div>
    </>
  );
}
